import { render } from "./Info-old.vue?vue&type=template&id=b350ab1a"
import script from "./Info-old.vue?vue&type=script&lang=js"
export * from "./Info-old.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__